<template>
   <span>
    <!-- No <notifications> host here: this component renders once per user row,
         and every mounted default-group host renders its own copy of each toast.
         UserSearch.vue provides the single page-level host. -->

     <a  @click="isOpen = !isOpen"  class="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem">
            <!-- Heroicon name: pencil-alt -->
            <svg class="mr-3 h-5 w-5 text-pink-500 group-hover:text-pink-700" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
              <path fill-rule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clip-rule="evenodd" />
            </svg>
            Edit
          </a>


     <transition v-if="isOpen"
                 enter-class="transition ease-out duration-100 transform"
                 enter-active-class="opacity-0"
                 enter-to-class="opacity-100"
                 leave-class="transition ease-in duration-200 transform"
                 leave-active-class="opacity-100"
                 leave-to-class="opacity-0"
     >
      <div  class="fixed z-50 inset-0 overflow-y-auto"  id="user-search-modal">
        <div class="flex items-start justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">

          <div class="fixed inset-0 transition-opacity" aria-hidden="true">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

          <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle xl:max-w-lg w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
            <div class="sm:flex sm:items-start">
              <div class="text-center sm:mt-0 sm:text-left w-full">
                <div class="flex justify-between items-center pb-3">
                  <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                    Edit: {{user.name}}
                  </h3>
                  <div @click="isOpen = false" class="modal-close cursor-pointer z-50" id="close-user-modal">
                    <svg  class="fill-current text-black" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path></svg>
                  </div>
                </div>
                <div class="my-3">

                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                    <label for="user_id" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      Name
                    </label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                      <input v-model="addForm.name" type="text" name="user_name" id="user_id" autocomplete="" class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300">
                    </div>
                  </div>

                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                    <label for="user_email" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      Email
                    </label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                      <input v-model="addForm.email" type="text"  id="user_email" class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300">
                    </div>
                  </div>

                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                    <label for="user_address" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      Address
                    </label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                      <input v-model="addForm.address" type="text"  id="user_address" class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300">
                    </div>
                  </div>

                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                    <label for="user_city" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      City
                    </label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                      <input v-model="addForm.city" type="text"  id="user_city" class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300">
                    </div>
                  </div>

                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                    <label for="state" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      State
                    </label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                      <select id="state"  v-model="addForm.state" class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                        <option value=""></option>
                        <option value="AL">Alabama</option>
                        <option value="AK">Alaska</option>
                        <option value="AS">American Samoa</option>
                        <option value="AZ">Arizona</option>
                        <option value="AR">Arkansas</option>
                        <option value="CA">California</option>
                        <option value="CO">Colorado</option>
                        <option value="CT">Connecticut</option>
                        <option value="DE">Delaware</option>
                        <option value="DC">District of Columbia</option>
                        <option value="FM">Federated States of Micronesia</option>
                        <option value="FL">Florida</option>
                        <option value="GA">Georgia</option>
                        <option value="GU">Guam</option>
                        <option value="HI">Hawaii</option>
                        <option value="ID">Idaho</option>
                        <option value="IL">Illinois</option>
                        <option value="IN">Indiana</option>
                        <option value="IA">Iowa</option>
                        <option value="KS">Kansas</option>
                        <option value="KY">Kentucky</option>
                        <option value="LA">Louisiana</option>
                        <option value="ME">Maine</option>
                        <option value="MH">Marshall Islands</option>
                        <option value="MD">Maryland</option>
                        <option value="MA">Massachusetts</option>
                        <option value="MI">Michigan</option>
                        <option value="MN">Minnesota</option>
                        <option value="MS">Mississippi</option>
                        <option value="MO">Missouri</option>
                        <option value="MT">Montana</option>
                        <option value="NE">Nebraska</option>
                        <option value="NV">Nevada</option>
                        <option value="NH">New Hampshire</option>
                        <option value="NJ">New Jersey</option>
                        <option value="NM">New Mexico</option>
                        <option value="NY">New York</option>
                        <option value="NC">North Carolina</option>
                        <option value="ND">North Dakota</option>
                        <option value="MP">Northern Mariana Islands</option>
                        <option value="OH" selected="selected">Ohio</option>
                        <option value="OK">Oklahoma</option>
                        <option value="OR">Oregon</option>
                        <option value="PW">Palau</option>
                        <option value="PA">Pennsylvania</option>
                        <option value="PR">Puerto Rico</option>
                        <option value="RI">Rhode Island</option>
                        <option value="SC">South Carolina</option>
                        <option value="SD">South Dakota</option>
                        <option value="TN">Tennessee</option>
                        <option value="TX">Texas</option>
                        <option value="UT">Utah</option>
                        <option value="VT">Vermont</option>
                        <option value="VI">Virgin Islands</option>
                        <option value="VA">Virginia</option>
                        <option value="WA">Washington</option>
                        <option value="WV">West Virginia</option>
                        <option value="WI">Wisconsin</option>
                        <option value="WY">Wyoming</option>
                      </select>
                    </div>
                  </div>

               <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                    <label for="user_city" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      Zip
                    </label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                      <input v-model="addForm.zip" type="text"  id="user_zip" class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300">
                    </div>
                  </div>


                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                    <label for="user_address" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      Phone
                    </label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                      <input v-model="addForm.phone" type="text"  id="user_phone" class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300">
                    </div>
                  </div>


                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                    <label for="user_role" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      Role
                    </label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                    <select v-model="addForm.role" id="user_role" name="user_role" autocomplete="" class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                        <option value=""></option>
                        <option value="member">Member</option>
                        <option value="admin">Admin</option>
                      </select>
                    </div>
                  </div>


                </div>
              </div>
            </div>
            <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
              <button @click="updateUser" class="w-full inline-flex justify-center border border-transparent shadow-sm px-4 py-2 bg-blue-500 text-base font-medium text-white hover:bg-blue-700 focus:outline-none  focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm">
                Update
              </button>
            </div>
          </div>
        </div>
      </div>

    </transition>

   </span>
</template>

<script>
import { buildHttpErrorNotification } from '../../http-error-notifier'

export default {
  name: 'EditAUser',
  props: {
    user: null,
  },
  data() {
    return {
      isOpen: false,
      selectedCampaignFromSearch: null,

      addForm: {
        id: this.user.id,
        name: this.user.name,
        email:  this.user.email,
        address:  this.user.address,
        city:  this.user.city,
        state:  this.user.state,
        zip:  this.user.zip,
        phone:  this.user.phone,
        role: this.user.role,
      },
    }
  },
  methods: {
    setOpenToFalse() {
      this.isOpen = false;
    },

    updateUser() {

      if (!this.addForm.name) {
        this.$notify({
          text: 'Name is required',
          type: 'error',
        })
        return
      }
      if (!this.addForm.email) {
        this.$notify({
          text: 'Email is required',
          type: 'error',
        })
        return
      }

      axios.post('/admin/user-search-update-user', this.addForm).then((response) => {
        if (response.data.message == 'error') {
          this.$notify({text: response.data.comment, type: 'error', })
          return
        }
        this.$notify({text: 'User updated',type: 'success', })

        this.emitter.emit('user-updated');

        this.isOpen = false
      })
      .catch(error => {
        // Without this the modal just sits there on a 403/419/500 and the
        // admin has no way to tell a denied request from a dead button.
        this.$notify(buildHttpErrorNotification(error))
      });
    },
  },


}
</script>
